import { FORMAT_MM_DD_YYYY, formatDate } from 'utils/dates'

export const getFormattedText = (text: string): JSX.Element[] =>
  text.split('\n').map((str, i) => <p key={i}>{str}</p>)

export const getFormattedAgreedOnTimeDate = (
  date: string,
  format = FORMAT_MM_DD_YYYY,
): string => {
  const dateStr = formatDate(date, format.toUpperCase())
  const timeStr = new Date(date).toLocaleTimeString()
  return Boolean(dateStr) ? `${dateStr} at ${timeStr}` : ''
}
